import styled from 'styled-components'

export const Wrapper = styled.div`
	padding: 2rem;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
`
